import classNames from 'classnames';
import * as React from 'react';
const ListItemContent = (props) => {
    const { prefix = 'cn-ui-m-', className, ...others } = props;
    return (React.createElement("div", { className: classNames(`${prefix}list-item-content`, className), ...others }));
};
export default ListItemContent;
